import useLayout from "@/lib/layout/useLayout";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/dashboard/fields")({
    component: RouteComponent,
});

function RouteComponent() {
    const { setLayoutState } = useLayout();
    useEffect(() => {
        setLayoutState("standard");
    }, [setLayoutState]);
    return <Outlet />;
}
